import type { DefaultTheme } from 'styled-components';

import { EdmStatus } from 'api/types/edm';

interface IEdmStatusColor {
    theme: DefaultTheme;
    status: EdmStatus;
}

export const edmStatusColor = ({ theme, status }: IEdmStatusColor): string => {
    switch (status) {
        case EdmStatus.NEW:
            return theme.colors.recommended;
        case EdmStatus.CONTACTED:
            return theme.colors.contacted;
        case EdmStatus.ACTIVE:
        case EdmStatus.LISTED:
            return theme.colors.responded;
        case EdmStatus.SOLD:
        case EdmStatus.ARCHIVE:
            return theme.colors.closed;
        default:
            return theme.colors.recommended;
    }
};
